import { MatrixRow } from "./MatrixRow";
import { MatrixObject } from "./MatrixObject";

interface MatrixCellInput extends HTMLInputElement {
    matrixCell: MatrixCell;
}

interface MatrixCellTextarea extends HTMLTextAreaElement {
    matrixCell: MatrixCell;
}


export class MatrixCell {
    type: string;
    rowSpan: number;
    colSpan: number;
    width: number;
    value: string;
    td: HTMLTableDataCellElement;
    //input: MatrixCellInput;
    input: MatrixCellTextarea | MatrixCellInput;
    rowIndex: number;
    colIndex: number;
    row: MatrixRow;
    isInRowSpan: boolean;
    isInColSpan: boolean;
    uniqueId: string; // used for Excel Import

    constructor(type: string, row: MatrixRow) {
        this.type = type;
        this.rowSpan = 1;
        this.colSpan = 1;
        this.width = 120;
        this.rowIndex = 0;
        this.colIndex = 0;
        this.value = "";
        this.row = row;
        this.isInRowSpan = false;
        this.isInColSpan = false;
        this.input = null;
        this.uniqueId = null;
    }

    createCell(cellControl: HTMLTableDataCellElement): void {
        let element: HTMLElement;


        try {
            if (this.isVisible()) {
                if (cellControl == null)
                    this.td = document.createElement('td');
                else
                    this.td = cellControl;
                this.td.colSpan = this.colSpan;
                this.td.rowSpan = this.rowSpan;
                this.td.style.whiteSpace = 'nowrap';

                if (this.row.matrixObject.useExcelImport) {
                    // value contains field id and content
                    if (this.value != null && this.value.length > 0) {
                        var idx = this.value.indexOf(";");
                        if (idx >= 0) {
                            this.uniqueId = this.value.substr(0, idx);
                            this.value = this.value.substr(idx + 1);
                        }
                    }

                    if (this.isField()) {
                        this.input = document.createElement('input') as MatrixCellInput;
                        this.input.type = 'text';
                        //this.input.style.fontSize = this.row.matrixObject.fontSize.toString() + 'px';
                        this.input.value = this.value;
                        this.td.appendChild(this.input);
                    }
                    else {
                        this.td.innerHTML = this.value;
                        this.td.className = "text";
                    }
                }
                else {
                    // create text 
 
                    //this.input.style.fontSize = this.row.matrixObject.fontSize.toString() + 'px';

                    if (this.isField()) {
                        this.input = document.createElement("input") as MatrixCellInput;
                        this.input.type = 'text';
                        this.input.className = "ro";
                        this.input.setAttribute("readonly", "readonly");
                        if (this.type == "f") {
                            this.input.value = this.row.matrixObject.getFieldName(this.value);
                        } else if (this.type == "n") {
                            this.input.value = "Name: " + this.row.matrixObject.getFieldName(this.value);
                        }
                        this.input.title = this.input.value;
                    }
                    else {
                        this.input = document.createElement('textarea') as MatrixCellTextarea;
                        this.input.rows = 1;
                        this.input.value = this.value;
                    }

                    this.td.appendChild(this.input);
                    this.input.matrixCell = this;

                    this.attachEvents();
                }
            }
        }
        catch (err) {
            alert("MatrixCell: error in cellCreate: " + err.message);
        }
    }

    attachEvents = () => {
        this.input.onfocus = (event: Event) => {
            MatrixObject.updateButtons((event.target as any).matrixCell);
        };


        this.input.onblur = function () {
            MatrixObject.updateButtons(null);
        };

        this.input.ondblclick = (event: Event) => {
            MatrixObject.onInputDoubleClick((event.target as any).matrixCell);
        }
    }

    isVisible(): boolean {
        return this.type != "h";
    }

    isField(): boolean {
        return this.type == "f" || this.type == "n";
    }

    isText(): boolean {
        return this.type == "t";
    }

    isHidden(): boolean {
        return this.type == "h";
    }

    updateModelState(row: MatrixRow, rowIndex: number, colIndex: number): void {
        try {
            // store new data
            this.rowIndex = rowIndex;
            this.colIndex = colIndex;
            this.row = row;

            if (this.isVisible()) {
                // column and row span
                if (this.colSpan) {
                    this.td.colSpan = this.colSpan;
                }
                if (this.rowSpan) {
                    this.td.rowSpan = this.rowSpan;
                }

                // set span helper variables
                this.isInColSpan = false;
                this.isInRowSpan = false;
                if (this.colSpan > 1) {
                    for (var i = this.colIndex + 1; i < (this.colIndex + this.colSpan); i++)
                        this.row.cells[i].isInColSpan = true;
                }
                if (this.rowSpan > 1) {
                    for (var i = this.rowIndex + 1; i < (this.rowIndex + this.rowSpan); i++)
                        this.row.matrixObject.rows[i].cells[this.colIndex].isInRowSpan = true;
                }

                // width
                if (this.width) {
                    var cellWidth = this.width;
                    //if (this.colSpan > 1) {
                    //    for (var i = this.colIndex + 1; i < (this.colIndex + this.colSpan); i++) {
                    //        cellWidth += this.row.cells[i].width + 7;
                    //    }
                    //}
                    this.td.style.width = cellWidth.toString() + "px";
                }
                
                if (this.input != null)
                    this.input.style.width = "100%";

                if (this.isField()) {

                    if (this.type == "f") {
                        this.row.matrixObject.setFieldUsed(this.value, true);

                    } else if (this.type == "n") {
                        this.row.matrixObject.setFieldNameUsed(this.value, true);
                    }
                }

                this.td.classList.remove("validation-failed");
            }
        }
        catch (err) {
            alert("MatrixCell: error in updateModelState: " + err.message);
        }
    }

    focus(): void {
        this.input.focus();
    }

    saveValues(): void {
        if (this.isText())
            this.value = this.input.value;
    }

    getLeftVisibleCell(): MatrixCell {
        var result: MatrixCell = this;
        if (this.isInColSpan) {
            while (result.isHidden()) {
                result = this.row.cells[result.colIndex - 1];
            }
        }
        return result;
    }

    getNextVisibleCell(): MatrixCell {
        var result: MatrixCell = null;
        var colIndex = this.colIndex + 1;
        while (colIndex < this.row.cells.length) {
            result = this.row.cells[colIndex];
            if (result.isVisible())
                return result;
            else
                colIndex++;
        }
        return result;
    }

    getTopVisibleColumn(): MatrixCell {
        var result: MatrixCell = this;
        if (this.isInRowSpan) {
            while (result.isHidden()) {
                result = this.row.matrixObject.rows[result.rowIndex - 1].cells[result.colIndex];
            }
        }
        return result;
    }

    textToField(): void {
        if (this.isText()) {
            this.type = "f";
            this.value = "";

            this.td.removeChild(this.input);
            this.input = document.createElement("input") as MatrixCellInput;
            this.input.matrixCell = this;
            this.input.className = "ro";
            this.input.type = "text";
            this.input.setAttribute("readonly", "readonly");
            this.td.appendChild(this.input);
            this.input.value = null;

            this.attachEvents();
        }
    }

    fieldToText(): void {
        if (this.isField()) {
            this.type = "t";
            this.value = "";

            this.td.removeChild(this.input);
            this.input = document.createElement("textarea") as MatrixCellTextarea;
            this.input.matrixCell = this;
            this.input.rows = 1;
            this.td.appendChild(this.input);
            this.input.className = null;
            this.input.removeAttribute("readonly");
            this.input.value = null;

            this.attachEvents();
        }
    }

    fieldEmpty(): void {
        if (this.isField()) {
            this.value = "";
            this.input.value = null;
        }
    }

    newField(id: string): void {
        if (this.isField()) {
            this.type = "f";
            if (id) {
                this.value = id;
                this.input.value = this.row.matrixObject.getFieldName(id);
            } else {
                this.value = null;
                this.input.value = null;
            }
        }
    }

    newFieldName(id: string): void {
        if (this.isField()) {
            this.type = "n";
            this.value = id;
            this.input.value = "Name: " + this.row.matrixObject.getFieldName(id);
        }
    }

    canDeleteColumn(): boolean {
        return this.row.cells.length > 1;
    }

    canMoveColumnLeft(): boolean {
        if (this.colIndex <= 0)
            return false;

        return !this.row.matrixObject.hasMergedCellsInColumn(this.colIndex) &&
            !this.row.matrixObject.hasMergedCellsInColumn(this.colIndex - 1);
    }

    canMoveColumnRight(): boolean {
        if ((this.colIndex + 1) >= this.row.cells.length)
            return false;

        return !this.row.matrixObject.hasMergedCellsInColumn(this.colIndex) &&
            !this.row.matrixObject.hasMergedCellsInColumn(this.colIndex + 1);
    }

    canIncreaseColumn(): boolean {
        return true;
    }

    canDecreaseColumn(): boolean {
        return this.width > this.row.matrixObject.minWidth;
    }

    canInsertRowAbove(): boolean {
        if (this.rowIndex > 0) {
            return !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex - 1);
        }
        return true;
    }

    canMergeRight(): boolean {
        if ((this.colIndex + this.colSpan) >= this.row.cells.length)
            return false;

        var nextCell = this.row.cells[this.colIndex + this.colSpan];
        // Prohibit mergin of cells if it would cross the border of fixed and free columns
        if (this.colIndex < this.row.matrixObject.fixedColumns && nextCell.colIndex >= this.row.matrixObject.fixedColumns) {
            return false;
        }
        if (nextCell && nextCell.isVisible()) {
            if (this.rowSpan != nextCell.rowSpan)
                return false;
            return true;
        }

        return false;
    }

    canSplitRight(): boolean {
        return this.colSpan > 1;
    }

    canMergeDown(): boolean {
        if ((this.rowIndex + this.rowSpan) >= this.row.matrixObject.rows.length)
            return false;

        var nextCell = this.row.matrixObject.rows[this.rowIndex + this.rowSpan].cells[this.colIndex];
        // Prohibit the merging of cells downwards if it would cross the border of fixed and free rows.
        if (this.rowIndex < this.row.matrixObject.fixedRows && nextCell.rowIndex >= this.row.matrixObject.fixedRows) {
            return false;
        }
        if (nextCell && nextCell.isVisible()) {
            if (this.colSpan != nextCell.colSpan)
                return false;
            return true;
        }

        return false;
    }

    canSplitDown(): boolean {
        return this.rowSpan > 1;
    }

    canInsertRowBelow(): boolean {
        return !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex);
    }

    canDeleteRow(): boolean {
        return !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex);
    }

    canMoveRowUp(): boolean {
        if (this.rowIndex > 0) {
            return !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex) &&
                !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex - 1);
        }
        return false;
    }

    canMoveRowDown(): boolean {
        if ((this.rowIndex + 1) >= this.row.matrixObject.rows.length)
            return false;

        return !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex) &&
            !this.row.matrixObject.hasMergedCellsInRow(this.rowIndex + 1);
    }

    static fromJson(object: any, parentMatrixRow: MatrixRow): MatrixCell {
        let res = <MatrixCell>Object.assign(new MatrixCell(null, parentMatrixRow), object);

        //set default values
        if (!res.width) res.width = 120;
        if (!res.rowSpan) res.rowSpan = 1;
        if (!res.colSpan) res.colSpan = 1;

        res.type = object.type ?? object.javascriptType;
        return res;
    }
}
